import React, { useState, useEffect } from 'react';
import { Accordion, AccordionBody, AccordionItem } from 'reactstrap';
import { useLocation } from 'react-router-dom';

import { categories, content } from './data';
import homeContent from 'assets/content/home.content.json';

import { ROUTES } from 'config/constants';

import IcPlus from 'assets/images/general/ic-plus-rounded.svg';
import IcMinus from 'assets/images/general/ic-minus-rounded.svg';

import './FAQ.scss';

export default function FAQ() {
    const location = useLocation();
    const defaultCategory = categories[0].key;
    const [activeCategory, setActiveCategory] = useState(defaultCategory);
    const [faq, setFaq] = useState([]);
    const [open, setOpen] = useState();
    const [headingClass, setHeadingClass] = useState();

    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    useEffect(() => {
        setFaq(content[activeCategory]);
    }, [activeCategory]);

    useEffect(() => {
        setFaq(content[defaultCategory]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (location.pathname === ROUTES.HOME) {
            setHeadingClass('faq__title__home');
        } else {
            setHeadingClass('');
        }
    }, [location.pathname]);

    return (
        <section id='faq' className='faq'>
            <p className={`faq__title ${headingClass}`}>{homeContent?.FAQ.FAQ}</p>
            <p className='faq__desc'>{homeContent?.FAQ.FAQ_DESC}</p>
            <div className='faq__types'>
                {categories.map((category) => (
                    <div key={category.key} onClick={() => setActiveCategory(category.key)}
                        className={`faq__types__type ${activeCategory === category.key ? 'active' : ''}`}>
                        {category.label}
                    </div>
                ))}
            </div>
            <div className='faq__content'>
                <Accordion open={open}>
                    { faq.map((faq) =>
                        <AccordionItem key={faq.id}>
                            <div className='faq__content__wrapper'>
                                <div className='faq__content__wrapper__item'>
                                    <p onClick={() => toggle(faq.id)}
                                        className='faq__content__wrapper__item__question'>{faq.question}</p>
                                    <AccordionBody accordionId={faq.id}>
                                        <p id={faq.id} className='faq__content__wrapper__item__answer'
                                            dangerouslySetInnerHTML={{ __html: faq.answer }} />
                                    </AccordionBody>
                                </div>
                                <img onClick={() => toggle(faq.id)}
                                    id={faq.id}
                                    className='faq__content__wrapper__icon'
                                    src={open && open === faq.id ? IcMinus : IcPlus}
                                    alt='Expand'/>
                            </div>
                        </AccordionItem>
                    )}
                </Accordion>
            </div>
        </section>
    );
}
